/**
 * Vizuálne tokeny obrazovky hlasovej linky.
 *
 * Držíme sa písma a palety admin panela – akcent je firemná modrá #2563EB.
 * Vlastné je len usporiadanie: scenár ako repliky na osi hovoru, nie formulár.
 */
export const getTokens = (isDark, primary = '#2563EB') => ({
    accent: primary,
    accentSoft: isDark ? 'rgba(37, 99, 235, 0.18)' : 'rgba(37, 99, 235, 0.10)',
    rec: '#F2452D',
    spine: isDark ? '#334155' : '#E2E8F0',
    hairline: isDark ? '#1e293b' : '#E8EBF0',
    surface: isDark ? '#0f172a' : '#ffffff',
    surfaceSunken: isDark ? '#111c30' : '#F8FAFC',
    ink: isDark ? '#f1f5f9' : '#111827',
    inkMuted: isDark ? '#94a3b8' : '#64748B',
});

/** Malý veľkopísmenový popisok – časovanie replík, stavy, hlavičky stĺpcov. */
export const cueLabelSx = (tokens) => ({
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    color: tokens.inkMuted,
    whiteSpace: 'nowrap',
});

/** Technický údaj (čas, trvanie, model) – tenší a tichší než bežný text. */
export const metaSx = (tokens) => ({
    fontSize: 11.5,
    letterSpacing: '0.01em',
    color: tokens.inkMuted,
});
